import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { RECOMMENDATIONS_API } from '../../constants/central-api';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

type actionPropTypes =
  | '/element/enable'
  | '/element/disable'
  | '/element/pause'
  | '/element/resume'
  | '/element/reject'
  | '/element/unarchive'
  | '/select'
  | '/unselect';

export default async function get_recommendations_api_call(
  method: 'POST' | 'PATCH',
  url: '/get' | actionPropTypes,
  id?: string
) {
  const shopId = store.getState().user?.company?.shop_id;
  const accessToken = store.getState().user?.stats?.ai_tracker_access_token;

  let body;
  if (method === 'POST') {
    body = { shop_id: shopId };
  } else {
    body = { id: id };
  }

  const requestInfo: RequestInfo = {
    url: `${RECOMMENDATIONS_API}${url}`, // Use the provided endpoint
    method: method,
    body: applicationWWWXRLEncodedBodyBuilder(body),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const actionType = 'RECOMMENDATIONS';
  const customMsg = 'Recommendation updated successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    true,
    false,
    true
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res?.actionType === actionType && response?.success === true) {
    if (method !== 'POST') {
      return true;
    } else if (response?.data === null) {
      return null;
    } else {
      return response?.data;
    }
  }
}
